module.exports = __webpack_public_path__ + "assets/icon-rating-star-outline-component.07802eec.svg";